const BACKOFFICEUSERS_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const BACKOFFICEUSERS_SORT_KEYS = {
  FULL_NAME: 0,
  EMAIL: 1,
  SUPER_USER: 2,
  DEVELOPER: 3,
  TWO_FACTOR_STATUS: 4,
  LAST_ACTIVE: 5,
  STATUS: 6,
};

const getBackofficeStatusSortValue = (backofficeUser) => {
  const normalizedStatus = backofficeUser?.is_active?.toString().toLowerCase();

  if (normalizedStatus === 'true') {
    return 2;
  }

  if (normalizedStatus === 'false') {
    return 0;
  }

  return 1;
};

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const sortKeys = [
  {
    name: 'Full Name',
    key: 'full_name',
    type: 'string',
    defaultSortType: BACKOFFICEUSERS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Email',
    key: 'email',
    type: 'string',
    defaultSortType: BACKOFFICEUSERS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Super User',
    key: 'is_superuser',
    type: 'boolean',
    defaultSortType: BACKOFFICEUSERS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Developer',
    key: 'is_developer',
    type: 'boolean',
    defaultSortType: BACKOFFICEUSERS_SORT_TYPES.DESCENDING,
  },
  {
    name: '2FA Status',
    key: 'two_factor_auth',
    type: 'boolean',
    defaultSortType: BACKOFFICEUSERS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Last Active',
    key: 'last_active_at',
    type: 'date',
    defaultSortType: BACKOFFICEUSERS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Status',
    type: 'number',
    getValue: getBackofficeStatusSortValue,
    defaultSortType: BACKOFFICEUSERS_SORT_TYPES.DESCENDING,
  },
];

const backofficeUsersQuickFilterConstants = {
  ALL: 1,
  TRUE: 2,
  FALSE: 3,
  WAIT: 4
};

export {
  BACKOFFICEUSERS_SORT_KEYS,
  BACKOFFICEUSERS_SORT_TYPES,
  sortTypes,
  sortKeys,
  backofficeUsersQuickFilterConstants,
};
